import { tokens as emojiPickerTokens } from '@pkg/components/GlobalSearch/EmojiPickerComboFloating/tokens';
import { tokens as fieldTextTokens } from '@pkg/components/forms/FieldText/FieldText.tokens';

export const tokens = {
    offset: (fieldTextTokens.height.small - emojiPickerTokens.action.size) / 2,
};
